module.exports = "./images/home-mediboard-img@2x.png?f6f32d16162051c5173906581dd59e3e";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-mediboard-img@2x.png
// module id = 158
// module chunks = 0